var _defs, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRentPayLogoBiznes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 124.88 47.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        stroke-width: 0px;\n      }\n\n      .cls-5 {\n        isolation: isolate;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n\n      .cls-6 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-7 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-4 {\n        fill: #12125a;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 10.42,
    y: 9.1,
    width: 96.71,
    height: 23.21
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -136.75,
    y1: 677.62,
    x2: -136.32,
    y2: 678.04,
    gradientTransform: "translate(1703.24 7940.14) scale(11.69 -11.69)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0711ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#9262cf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#e5117f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f5016f"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 99.82,
    y: 11.01,
    width: 10.38,
    height: 6.02
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_174",
    "data-name": "Group 174"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_127",
    "data-name": "Group 127"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    className: "cls-4",
    d: "m10.51,11.1c0-.09.09-.18.18-.27.24-.74.95-1.22,1.72-1.18h6.71c.86-.02,1.72.1,2.54.36,1.32.35,2.33,1.39,2.63,2.72.1.63.17,1.26.18,1.9.09,1.06-.27,2.12-1,2.9-.36.38-.79.69-1.27.91-.09,0-.09.09-.18.09,0,.09.09.09.09.18l.82.54c.42.29.69.76.73,1.27.22.92.32,1.87.27,2.81,0,.91.09,1.81.18,2.72.04.3.17.58.36.82h-3.35c-.36,0-.45,0-.45-.36-.1-.5-.17-1.02-.18-1.53-.09-.91-.09-1.72-.18-2.63-.05-.4-.14-.8-.27-1.18-.22-.51-.71-.86-1.27-.91-.96-.12-1.93-.15-2.9-.09h-1.54q-.36,0-.36.36v6.07c0,.27-.09.27-.27.27h-3.27c.09-5.26.09-10.52.09-15.78m6.17,1.45h-2.27q-.36,0-.36.36v3.9q0,.36.36.36h3.81c.43-.02.85-.08,1.27-.18.45-.06.86-.33,1.09-.73.25-.44.37-.94.36-1.45,0-.41-.1-.81-.27-1.18-.33-.7-1.05-1.13-1.82-1.09h-2.18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    className: "cls-4",
    d: "m37.8,22.89c-.3,1.44-1.14,2.71-2.36,3.54-1.07.55-2.25.83-3.45.82-1.1.03-2.19-.22-3.17-.73-1.04-.5-1.84-1.38-2.27-2.45-.39-.92-.61-1.9-.63-2.9v-2.45c.07-1.47.68-2.86,1.72-3.9.53-.48,1.14-.85,1.81-1.09.84-.3,1.74-.42,2.63-.36,1.25-.03,2.49.31,3.54,1,.93.66,1.61,1.62,1.9,2.72.38,1.29.53,2.64.45,3.99,0,.18-.09.18-.27.18h-8.16c-.36,0-.45,0-.36.45.08.54.27,1.07.54,1.54.62.86,1.68,1.29,2.72,1.09.63-.17,1.22-.48,1.72-.91.29-.29.68-.46,1.09-.45h2.18c.11-.06.24-.09.36-.09m-5.89-4.08h2.27c.18,0,.36,0,.27-.27-.1-.47-.25-.93-.45-1.36-.51-.88-1.55-1.32-2.54-1.09-.63.1-1.2.46-1.54,1-.27.44-.46.94-.54,1.45-.09.36,0,.36.27.36.75-.07,1.51-.1,2.27-.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    className: "cls-4",
    d: "m50.77,22.43v4.26c0,.18-.09.27-.27.18h-1.63c-.8,0-1.45-.66-1.45-1.46,0-.03,0-.06,0-.08v-6.71c0-.47-.09-.93-.27-1.36-.28-.57-.82-.98-1.45-1.09-.63-.16-1.31-.1-1.9.18-.55.19-.95.69-1,1.27-.08.39-.11.78-.09,1.18v7.89c.02.13-.07.25-.2.27-.02,0-.05,0-.07,0h-2.9c-.13.02-.25-.07-.27-.21,0-.02,0-.04,0-.07v-8.07c-.03-1.04.22-2.08.73-2.99.56-1.13,1.65-1.91,2.9-2.09.74-.18,1.5-.27,2.27-.27,1.17-.05,2.34.23,3.36.82.93.62,1.6,1.55,1.9,2.63.18.77.27,1.56.27,2.36,0,1.18,0,2.27.09,3.35h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    className: "cls-4",
    d: "m51.86,17.36v-7.44c0-.27.09-.27.27-.27h1.45c.8.05,1.45.66,1.54,1.45v2q0,.36.36.36h1.45c.13-.02.25.07.27.2,0,.02,0,.05,0,.07.04.43-.03.87-.18,1.27-.26.51-.79.83-1.36.82q-.45,0-.45.45v6.98c-.05.5.31.95.8,1,.07,0,.13,0,.2,0h.91c.13-.02.25.07.27.2,0,.02,0,.05,0,.07v2.08c0,.18-.09.18-.18.18h-3.26c-.72.03-1.38-.41-1.63-1.09-.1-.35-.16-.72-.18-1.09-.23-2.41-.32-4.83-.27-7.25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    className: "cls-4",
    d: "m58.93,18.44v-8.07c0-.54.09-.63.63-.63h6.89c1.21-.04,2.4.34,3.35,1.09.61.55,1.03,1.28,1.18,2.09.16.71.19,1.45.09,2.18-.05,1.56-1.01,2.94-2.45,3.54-.97.43-2.02.64-3.08.63h-4.53c-.36,0-.45,0-.45.45v7.08c0,.27-.09.27-.27.27h-1.09c-.18,0-.27,0-.27-.27v-8.35Zm1.63-4.08v3.08q0,.36.36.36h4.62c.55-.02,1.09-.08,1.63-.18.75-.16,1.41-.62,1.81-1.27.47-.79.7-1.71.63-2.63-.02-1.09-.7-2.06-1.72-2.45-.66-.26-1.37-.38-2.09-.36h-4.9c-.36,0-.36.09-.36.36v3.08"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    className: "cls-4",
    d: "m83.5,19.62v3.35c-.01.63-.17,1.25-.45,1.81-.36.71-.98,1.26-1.72,1.54-1.06.46-2.2.7-3.35.73-.85.08-1.71.01-2.54-.18-1.22-.14-2.28-.89-2.81-2-.27-.72-.37-1.5-.27-2.27.19-1.22.97-2.28,2.09-2.81,1.03-.48,2.13-.79,3.26-.91.95-.06,1.87-.31,2.72-.73.38-.21.75-.45,1.09-.73.64-.61.67-1.62.07-2.26-.15-.16-.32-.28-.52-.37-.56-.29-1.18-.44-1.81-.45h-1.81c-.73,0-1.43.26-1.99.73-.29.27-.51.62-.63,1,0,.09-.18.18-.18.18h-1.18c-.18,0-.27-.09-.18-.27.15-.93.72-1.73,1.54-2.18.59-.33,1.23-.55,1.9-.64.6-.12,1.21-.15,1.81-.09,1.02-.03,2.03.12,2.99.45.69.18,1.28.64,1.63,1.27.19.4.28.83.27,1.27.05.54.05,1.09,0,1.63.07.63.1,1.27.09,1.9m-1.63,1.54h0v-1.99c0-.27-.09-.27-.27-.18-.27.09-.45.27-.73.36-.82.27-1.54.45-2.36.73-.83.16-1.65.37-2.45.64-1.31.33-2.19,1.55-2.09,2.9-.06,1.11.72,2.08,1.81,2.27,1.52.4,3.13.24,4.53-.45.96-.38,1.57-1.33,1.54-2.36v-1.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    className: "cls-4",
    d: "m85.86,13.55h1.54c.09,0,.09.09.18.18l.54,1.63c.18.64.45,1.36.63,2,.36,1,.63,1.9,1,2.9l.82,2.45c.18.64.45,1.36.63,2,0,.07.04.13.09.18.09-.09.18-.09.18-.18.08-.35.2-.68.36-1,.27-.82.54-1.54.82-2.36l.82-2.45c.2-.68.44-1.34.72-1.99.27-.82.54-1.54.82-2.36.08-.29.2-.56.36-.82.09-.18.36-.18.63-.18h.63c.27,0,.27.09.18.27-.19.44-.34.89-.45,1.36-.27.82-.54,1.54-.82,2.36-.36.91-.63,1.81-1,2.72s-.63,1.81-1,2.81c-.36.91-.63,1.81-1,2.72-.27.73-.54,1.54-.82,2.27-.3,1.11-.79,2.15-1.45,3.08-.6.79-1.55,1.23-2.54,1.18-.13.02-.25-.07-.27-.21,0-.02,0-.04,0-.07v-.64c-.02-.13.07-.25.21-.27.02,0,.04,0,.07,0,1.45.18,2.72-1.54,2.72-2.81-.03-1.15-.24-2.28-.63-3.35-.36-.91-.63-1.81-.91-2.63s-.54-1.54-.82-2.36c-.36-.91-.63-1.81-1-2.72s-.63-1.81-1-2.72c0-.35-.1-.7-.27-1"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_175",
    "data-name": "Group 175"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    className: "cls-1",
    cx: 105.58,
    cy: 14.56,
    r: 5.85
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_152",
    "data-name": "Group 152"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_151",
    "data-name": "Group 151"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    className: "cls-3",
    d: "m106,11.01c-.43,0-.81.29-.92.71l-.82,3.21-.53-2.51c-.09-.4-.45-.69-.86-.69h0c-.41,0-.77.28-.86.69l-.52,2.51-.38-1.56c-.11-.41-.48-.69-.9-.69h-.15c-.05.14-.1.3-.14.47s-.07.34-.09.48l.82,2.79c.14.45.62.7,1.07.56.29-.09.51-.32.58-.62l.57-2.6.57,2.6c.11.46.57.74,1.03.63.29-.07.53-.29.62-.58l1.6-5.42h-.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    className: "cls-3",
    d: "m107.78,14.6v.42c0,.08.06.14.14.14h2.26c.04-.36.01-.73-.08-1.09-.06-.33-.21-.64-.43-.89-.12-.13-.27-.24-.43-.33-.34-.19-.72-.28-1.11-.27-.57-.02-1.12.2-1.52.62-.37.45-.56,1.02-.53,1.6-.02.59.17,1.17.55,1.63.36.39.87.61,1.41.6h1.43c0-.61-.48-1.1-1.09-1.11,0,0,0,0-.01,0h-.21c-.13,0-.25-.03-.36-.09-.07-.04-.13-.09-.18-.14-.03-.03-.05-.07-.07-.11-.02-.03-.03-.07-.04-.11-.06-.21-.09-.42-.1-.64,0-.22.03-.44.11-.64.03-.11.08-.22.16-.31.13-.12.31-.19.49-.17.18,0,.36.06.5.17.1.12.16.26.17.41h-.74c-.17,0-.3.14-.3.31"
  })))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "biznes",
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m16.14,35.18c.31.38.46.83.46,1.34,0,.71-.24,1.27-.71,1.69-.48.41-1.17.62-2.07.62h-3.64v-8.47h3.56c.86,0,1.51.19,1.97.56.46.38.69.9.69,1.58,0,.53-.14.96-.41,1.3s-.64.56-1.09.66c.51.1.92.35,1.23.73Zm-4.27-1.28h1.52c.42,0,.75-.09.97-.28.22-.19.33-.46.33-.81s-.11-.62-.32-.82c-.22-.19-.55-.29-1-.29h-1.5v2.2Zm2.64,3.25c.24-.2.36-.48.36-.86s-.12-.67-.37-.87c-.24-.2-.59-.31-1.04-.31h-1.6v2.33h1.61c.45,0,.79-.1,1.03-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m19.48,30.35v8.47h-1.69v-8.47h1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m22.65,37.45h3.95v1.37h-5.82v-1.3l3.86-5.82h-3.8v-1.36h5.71v1.3l-3.9,5.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m35.07,38.82h-1.69l-3.79-5.76v5.76h-1.69v-8.47h1.69l3.79,5.81v-5.81h1.69v8.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m38.3,31.69v2.2h3v1.3h-3v2.28h3.36v1.36h-5.05v-8.47h5.05v1.34h-3.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m48.4,37.69c-.22.36-.54.66-.96.88-.42.22-.94.33-1.55.33s-1.14-.1-1.61-.31-.85-.5-1.13-.88c-.28-.38-.45-.83-.49-1.34h1.8c.04.34.18.63.41.86.24.23.55.34.94.34.35,0,.62-.09.81-.28.19-.19.28-.43.28-.73,0-.26-.08-.48-.23-.65s-.34-.31-.58-.41c-.23-.1-.55-.22-.96-.36-.53-.18-.96-.35-1.3-.52s-.62-.42-.86-.75-.35-.76-.35-1.28c0-.73.26-1.3.79-1.72s1.22-.63,2.08-.63,1.61.22,2.14.65c.53.43.83,1.01.91,1.73h-1.82c-.05-.3-.18-.55-.38-.75s-.49-.29-.85-.29c-.31,0-.56.08-.76.25s-.29.4-.29.71c0,.25.07.45.22.62.15.16.34.3.56.4.23.1.54.22.93.35.54.19.99.37,1.33.54s.63.42.87.76c.24.34.36.78.36,1.32,0,.43-.11.83-.32,1.19Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRentPayLogoBiznes);
export default __webpack_public_path__ + "static/media/rentPayLogoBiznes.912bbb79074abef612495c123edb2829.svg";
export { ForwardRef as ReactComponent };